// supabase.ts
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';
import { cookieStorage } from './cookie-storage';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Check for undefined values and throw error if missing
if (!supabaseUrl || !supabaseAnonKey) {
  console.error("ERROR: Supabase configuration is incomplete!");
  console.error("Make sure you have the following environment variables set in your .env file:");
  console.error("VITE_SUPABASE_URL");
  console.error("VITE_SUPABASE_ANON_KEY");
  throw new Error("Supabase configuration is missing. Check your .env file.");
}

// Cookie-based storage shares auth session across *.zenmusicgroup.com subdomains.
// Falls back to localStorage on localhost / other hosts.
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public'
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,  // Disable automatic URL detection to handle password reset manually
    storage: cookieStorage,
  }
});